import React, { useState, Suspense, lazy } from "react";
const ProfileTab = lazy(() => import("./tabs/ProfileTab"));
const AccountTab = lazy(() => import("./tabs/AccountTab"));
const MembershipTab = lazy(() => import("./tabs/MembershipTab"));
const RegulatoryInfoTab = lazy(() => import("./tabs/RegulatoryInfo"));
const BillingConfigTab = lazy(() => import("./tabs/BillingConfig"));

const tabs = [
    { id: "profile", label: "Profile" },
    { id: "account", label: "Account" },
    { id: "membership", label: "Membership" },
    { id: "regulatory", label: "Regulatory Info" },
    { id: "billing", label: "Billing Config" },
];

const RestaurantSettings: React.FC = () => {
    const [activeTab, setActiveTab] = useState("profile");

    const renderTab = () => {
        switch (activeTab) {
            case "account":
                return <AccountTab />;
            case "membership":
                return <MembershipTab />;
            case "regulatory":
                return <RegulatoryInfoTab />;
                case "billing":
                return <BillingConfigTab />;
            default:
                return <ProfileTab />;
        }
    };

    return (
        <div className="max-w-3xl mx-auto px-6 py-8 text-gray-900 dark:text-gray-100">
            <h1 className="text-2xl font-bold mb-6 text-orange-500 flex items-center gap-2">
                ⚙️ Settings
            </h1>
            <div className="flex border-b border-gray-200 dark:border-gray-700 mb-6">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`px-4 py-2 -mb-px border-b-2 text-sm font-medium ${activeTab === tab.id
                            ? "border-orange-500 text-orange-500"
                            : "border-transparent text-gray-500 dark:text-gray-400 hover:text-orange-400"
                            }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            <Suspense fallback={<p>Loading...</p>}>{renderTab()}</Suspense>
        </div>
    );
};

export default RestaurantSettings;
